<section>
  <div class="container-fluid">
    <div class="row justify-content-center">
      <div class="col-6 pe-0">
        <app-account-request></app-account-request>
      </div>
    </div>
  </div>
</section>
